import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, reset } from 'redux-form';
import OverchargeRfcDialog from './OverchargeRfcDialog';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  values: getFormValues('OverchargeRfcForm')(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('OverchargeRfcForm'),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OverchargeRfcDialog);
